import {ExpressionElement} from '@packages/systems/wfdl-ast';
import {
  isFormCheckboxWrapper,
  isUserFormCheckboxInput,
} from '@packages/utilities/elementTypeUtils';
import {findElementDescendant} from '@packages/utilities/platform';

export function isUserFormCheckboxWrapper(element: ExpressionElement): boolean {
  return (
    isFormCheckboxWrapper(element) &&
    Boolean(findElementDescendant(element, isUserFormCheckboxInput))
  );
}
